import React from "react";
import { graphql } from "react-relay";

import { type ApiKey, ApiKeySection } from "~/account/Security/DeveloperApi/ApiKeySection";

import type {
	UserApiKeysSectionQuery,
	UserApiKeysSectionQuery$data as UserApiKeysSectionQueryType,
} from "~/__generated__/UserApiKeysSectionQuery.graphql";

import styles from "./UserApiKeysSection.module.css";

const userApiKeysQuery = graphql`
	query UserApiKeysSectionQuery {
		userApiKeys {
			id
			name
			createdAt
			lastUsed
			isActive
			owner {
				id
				email
			}
		}
	}
`;

interface UserApiKeysSectionProps {
	enabled: boolean;
}

export const UserApiKeysSection = (props: UserApiKeysSectionProps) => {
	const dataSelector = React.useCallback((data: UserApiKeysSectionQueryType) => data.userApiKeys as ApiKey[], []);

	return (
		<ApiKeySection<UserApiKeysSectionQuery, UserApiKeysSectionQueryType>
			className={styles.userApiKeysSection}
			query={userApiKeysQuery}
			dataSelector={dataSelector}
			sectionTitle=""
			enabled={props.enabled}
			emptyStateTitle="No API keys yet"
			emptyStateDescription="Create an API key to connect Fellow with your tools or build something custom."
			showOwner={false}
			showNewKeyButton
		/>
	);
};
